import React from 'react'
import ReactMarkdown from 'react-markdown'
import { get } from "lodash"

import { getEmptyTransport } from '../../lib/emptyTransport.js'
import { getTransportationLabel, translateCity, getText } from '../../lib/text.js'
import { linkifyMarkdown } from '../../../lib/Tools.js'

import ItemTemplate from './ItemTemplate'
import { TransportItemEditor } from '../../trips/Transport.jsx'

/**
 *
 */

const City = props => {
  const { item, city } = props

  const tmeans = item.transport && item.transport.means
  const means = get(item, "transport.means", false) && getTransportationLabel(item.transport.means, { withIcon: true })

  const cnotes = city.notes
  const tnotes = item.transport ? item.transport.notes : ""
  const customFee = item.useCustomFee ? `${item.customFee}%` : null

  const title = (
    (tmeans === "airplane" && (getText("avion_a") + translateCity(city)))
    || (tmeans === "train" && (getText("tren_a") + translateCity(city)))
    || (tmeans === "bus"   && (getText("bus_a") + translateCity(city)))
    || (
      (tmeans === "rental" || tmeans === "guide" || tmeans === "private")
      && (getText("coche_a") + translateCity(city))
    )
    || `${getText("viaje_a_1")}${translateCity(city)}${getText("viaje_a_2")}`
  )

  return (
    <ItemTemplate
      {...props}
      icon="plane"
      title={title}
      subtitle={`(${means || "?"}, ${item.time || "?"})`}
      description={(
        <div>
          {cnotes && (<ReactMarkdown source={linkifyMarkdown(cnotes)} />)}
          {
            tnotes && (
              <ReactMarkdown style={{ display: "inline" }} source={"**Transporte:** " + linkifyMarkdown(tnotes)} />
            )
          }
          {customFee && <div>Gastos gestión: {customFee}</div>}
        </div>
      )}
      modal={
        () => (
          <TransportItemEditor
            item={item}
            transport={item.transport || getEmptyTransport(item.city)}
            city={city}
            onChange={(k, v) => props.editItem(props.routeId, props.i, k, v)}
            time={item.time || ""}
            onClose={() => props.onEndEdit()}
          />
        )
      }
    />
  )
}

export default City
